Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "tabs2879793129",
  {"root":"tabs2879793129--root","mobile":"tabs2879793129--mobile"},
  "",
  4,
  "tabs2879793129"
);

